import { Button } from "@mui/material";
import styled from "styled-components";

export const CancelButtonStyled = styled(Button)`
  border-color: ${({ theme }) => theme.colors.button.blue} !important;
  padding: 5px 16px !important;
  border-radius: 8px !important;
  color: ${({ theme }) => theme.colors.button.blue} !important;
  background-color: transparent !important;
  text-transform: capitalize !important ;
`;
